/**
 * One gross-margin formula for every simulator surface, identical to the
 * backend record (packing_analysis_views.py, Step 5.5):
 *
 *   margin = value - product cost - commission + shipping charged - shipping cost
 *   margin % = margin / value
 *
 * `value` and `cost` are the line totals (unit_price / cost x quantity).
 */
export const productTotals = (products = []) => products.reduce(
  (t, p) => {
    const qty = Number(p.quantity) || 0;
    t.value += (Number(p.unit_price) || 0) * qty;
    t.cost += (Number(p.cost) || 0) * qty;
    t.items += qty;
    return t;
  },
  { value: 0, cost: 0, items: 0 },
);

export const grossMargin = ({ value = 0, cost = 0, commission = 0, charged = 0, shipping = 0 }) => {
  const amount = value - cost - commission + charged - shipping;
  return { amount, pct: value > 0 ? (amount / value) * 100 : null };
};

/** The healthy margin bar used by the decision strip and the margin alert. */
export const HEALTHY_MARGIN_PCT = 20;
